<div class="tile-row">
  @for (group of $config().groups; track group.id) {
    <wb-button class="tile" [iconLeft]="group.icon" [label]="group.label" [displayStyle]="displayStyleFor(group.id)" (onClick)="onTileClick(group.id)" />
  }
</div>

<div class="prompt-list" [class.expanded]="$activeGroup() !== null">
  @for (prompt of $activeGroup()?.prompts ?? []; track prompt) {
    <button type="button" class="prompt-item" (click)="onPromptClick(prompt)">{{ prompt }}</button>
  }
</div>
